import React, { useState, useEffect } from "react";
import {
  BellOutlined,
  LogoutOutlined,
  SettingOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { useMachines } from "../../context/MachineContext";
import { NavLink, useNavigate } from "react-router-dom";
import axios from "axios";
import { Link } from "react-router-dom";

const Navbar = ({ user, setUser }) => {
  const { machines } = useMachines();
  const [notifications, setNotifications] = useState([]);
  const navigate = useNavigate();

  const apiUrl = process.env.REACT_APP_MONGO_URL;

  const notification = 1;
  const activeMachinesCount = machines.filter(
    (machine) => machine.status === "active"
  ).length;
  const notActiveMachinesCount = machines.filter(
    (machine) => machine.status === "inactive"
  ).length;
  const maintenanceMachinesCount = machines.filter(
    (machine) => machine.status === "maintenance"
  ).length;

  // State for notification and profile menu
  const [isNotificationOpen, setNotificationOpen] = useState(false);
  const [isProfileMenuOpen, setProfileMenuOpen] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem("token");
    setUser(null);
    navigate("/login");
  };

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const response = await axios.get(`${apiUrl}/api/notification`); // Backend'deki API endpoint
        const formattedNotifications = response.data
          .map((notification) => {
            const date = new Date(notification.time);
            const formattedTime = date.toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            });
            return { ...notification, time: formattedTime, rawTime: date }; // rawTime ekleniyor
          })
          .sort((a, b) => b.rawTime - a.rawTime); // Yeniden eskiye sıralama
        setNotifications(formattedNotifications); // Bildirimleri state'e kaydet
      } catch (error) {
        console.error("Error fetching notifications:", error);
      }
    };

    fetchNotifications();
  }, [apiUrl]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".menu")) {
        setNotificationOpen(false);
        setProfileMenuOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <div className="flex justify-between items-center bg-white p-4 fixed top-0 left-64 w-[calc(100%-16rem)] z-50">
      {/* Logo */}
      <div className="flex items-center ml-6">
        <NavLink to="/" className="logo">
          <img
            src="/softrein.png"
            alt="Softrein Logo"
            style={{ height: "30px" }}
          />
        </NavLink>
      </div>

      {/* Machine Status */}
      <div className="flex items-center space-x-4 text-sm text-gray-600">
        <div className="flex items-center">
          <span className="text-gray-500 mr-2">Toplam Makine:</span>
          <span className="font-bold">{machines.length}</span>
        </div>
        <div className="flex items-center">
          <span className="text-green-500 mr-2">Aktif:</span>
          <span className="font-bold">{activeMachinesCount}</span>
        </div>
        <div className="flex items-center">
          <span className="text-red-500 mr-2">Pasif:</span>
          <span className="font-bold">{notActiveMachinesCount}</span>
        </div>
        <div className="flex items-center">
          <span className="text-yellow-500 mr-2">Bakımda:</span>
          <span className="font-bold">{maintenanceMachinesCount}</span>
        </div>
      </div>

      {/* Notification and Profile */}
      <div className="flex items-center space-x-4 relative">
        {/* Notification Icon */}
        <div className="relative menu">
          <span
            className="cursor-pointer text-gray-400 relative hover:text-gray-600"
            onClick={() => setNotificationOpen(!isNotificationOpen)}
          >
            <BellOutlined className="hover:scale-75 transition-transform duration-300 ease-in-out transform" />
            {notification === 0 ? null : (
              <span className="absolute top-0 right-0 w-1.5 h-1.5 bg-red-500 rounded-full"></span>
            )}
          </span>
          {isNotificationOpen && (
            <div className="absolute right-0 mt-2 w-64 bg-white shadow-lg rounded-md p-4 z-50">
              <h4 className="text-sm font-semibold mb-3 text-center">
                Bildirimler
              </h4>
              <ul>
                {notifications.map((notification, index) => (
                  <li
                    key={notification.id}
                    className="text-sm text-gray-600 mb-2"
                  >
                    <div className="flex justify-between">
                      <span>{notification.message}</span>
                      <span className="text-gray-400 text-xs">
                        {notification.time}
                      </span>
                    </div>
                    {index < notifications.length - 1 && (
                      <hr className="my-2 border-gray-200" />
                    )}
                  </li>
                ))}
              </ul>
              <div className="mt-2 text-center text-gray-400 text-sm">
                Tüm Bildirimler
              </div>
            </div>
          )}
        </div>

        {/* Profile Icon */}
        <div className="relative menu">
          <div
            className="flex items-center cursor-pointer"
            onClick={() => setProfileMenuOpen(!isProfileMenuOpen)}
          >
            <span className="text-gray-600 mr-2">Yasin Ak</span>
            <img
              src="https://ui-avatars.com/api/?name=Yasin+Ak"
              alt="User Avatar"
              className="w-10 h-10 rounded-full"
            />
          </div>
          {isProfileMenuOpen && (
            <div className="absolute right-0 mt-2 w-48 bg-white shadow-lg rounded-md p-4 z-50">
              <ul className="space-y-2">
                <Link to="/profile">
                  <li className="flex items-center text-sm text-gray-600 cursor-pointer hover:text-gray-900">
                    <UserOutlined className="mr-1" />
                    Profil
                  </li>
                </Link>
                <hr className="my-2 border-gray-200" />
                <Link to="/settings">
                  <li className="flex items-center text-sm text-gray-600 cursor-pointer hover:text-gray-900">
                    <SettingOutlined className="mr-1" />
                    Ayarlar
                  </li>
                </Link>
                <hr className="my-2 border-gray-200" />
                <Link onClick={handleLogout}>
                  <li className="flex items-center text-sm text-red-500 cursor-pointer hover:text-red-700">
                    <LogoutOutlined className="mr-1" />
                    Çıkış Yap
                  </li>
                </Link>
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Navbar;
